import React,{ useState,useEffect,useRef } from 'react';
import MenuExteriorView from './MenuExteriorView';
import MenuInterierView from './MenuInterierView';
import AnimationBtn from './AnimationBtn';
import MenuSoftware from './MenuSoftware';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';

var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1) || (navigator.userAgent.indexOf("Mobile") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15");
var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
var isipad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1);

export const userContext = React.createContext();

var buttonSeq = ['onResetMode','onExteriorClick','FrontModeClick','RearModeClick','onInterirorClick','onProcessorClick','onMemoryClick','onFanClick','onSoftwareClick','onEmbededClick','onOpenManageClick'];

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);

   const [animValue,setAnimValue] = useState("on");

   const [animValue1,setAnimValue1] = useState("on");


   const handleAccordionChange = (panel) => (event,isExpanded) => {

      if (isExpanded) {
         setExpandedPanel(panel);
      } else {
         setExpandedPanel(false)
      };

      // resetBacklitCloseImg();
      // console.log('in expanded things')
      if(window.innerHeight < 720){
         if(isExpanded == true && panel == 'panel3'){
            if(document.querySelector("#logoIntelDiv") != null){
               if(window.mob == true && window.innerHeight< window.innerWidth){
                  document.querySelector("#logoIntelDiv").style.position = 'initial';
                  document.querySelector("#logoIntelDiv").style.bottom = '450px';
               }else {
                  document.querySelector("#logoIntelDiv").style.position = 'initial';
               }
              
            }
         }else {
            if(document.querySelector("#logoIntelDiv") != null){
               document.querySelector("#logoIntelDiv").style.position = 'initial';
            }
         }
      }else {
         if(document.querySelector("#logoIntelDiv") != null && !window.isipad){
            document.querySelector("#logoIntelDiv").style.position = 'fixed';
         }
      }
      

   };

   const [camData,setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;
   var animTimes = 1;

   const getData = () => {
      fetch('./model_gl/config.json')
         .then(function (response) {
            return response.json();
         })
         .then(function (myJson) {
            setCamData(myJson.positions);
         });
   }

   useEffect(() => {
      getData();
      window.getLangTranscript();
      animationSwitch = window.Animation;
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      window.position = 'reset';
      return () => {
         return false
      }
   },[]);

   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }

      return () => {
         return false
      }

   },[])
   
   useEffect((event) => {
      if (event) {
         if (event.keyCode === 13) {
            this.click();
         }
      }
      return () => {
         return false
      }

   })
 
   //For Animation Switch 
   // console.log('animationSwitch anim', animationSwitch)

   if (animationSwitch == 'on') { animTime = 1000; animTimes = 2000 }
   else { animTime = 1; animTimes = 1 }

   //new camera function
   const GotoPosInTimeNamedValue = (gotoposname,onComplete,onSample) => {
      // below code is updated in it.  
      // updated code ends here 

      var opt = undefined,gp = camData[gotoposname];

         // console.log(gotoposname)
      if (gp.fovy && window.scene.fovy != gp.fovy)
         opt = { fovy: gp.fovy };
      if (gp.pos.length > 5) {
         if (!opt)
            opt = {};
         opt.zang = gp.pos[5];
      }
      if (animationSwitch == 'off') {
         gp.time = 1
      }
      else {
         gp.time = animTime;
      }
      if(window.isMac && !(window.mob||window.isipad)){
         // console.log('isImac')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4]+20, gp.time, onComplete, onSample, opt);
      }
    else if(window.mob||window.isipad){
         // console.log('isipad')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4] + 70, gp.time, onComplete, onSample, opt);
      }
      else if(window.innerWidth >= 1200 && window.innerWidth <= 1300 && !window.isipad){
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4]+90, gp.time, onComplete, onSample, opt);
      }
      else{
         // console.log('desk')
         window.scene.gotoPosInTime(gp.pos[0], gp.pos[1], gp.pos[2], gp.pos[3], gp.pos[4], gp.time, onComplete, onSample, opt);
      }
   }

   //end
   const slowInOut = (x) => {
      var a = 2.1;
      var x2 = 1.0 - x;
      var px = Math.pow(x,a);
      var px2 = Math.pow(x2,a);

      return px / (px + px2);
   }

   const clearSlideSetTimeout = useRef(null);

   const sliderRangeBarUpdate = () => {
      let slider = document.getElementById("sliderRange");
      if (slider !== null) {
         slider.value = window.scene._nav.getZoomFactor();
         clearSlideSetTimeout.current = setTimeout(() => {
            slider.value = window.scene._nav.getZoomFactor()
         },1000);
      }
   }

   const reverseAll = () => {

      // window.scene._nav.tempfRotMinLimit = 0.02;
      window.scene._nav._panMax  = [16,10];   //[left, bottom];
      window.scene._nav._panMin = [-16,-2];  //[right, top];

      clearTimeout(clearSlideSetTimeout.current);

      for (let alreadySelected of document.querySelectorAll('.MuiAccordionDetails-root.active,.MuiAccordionDetails-root.select')) {
         if (alreadySelected !== null) {
            alreadySelected.classList.remove('active','select');
         }
      }

      for (let hotspot of document.querySelectorAll(".hotspots")) {
         if (hotspot !== null) {
            hotspot.style.display = 'none';
            hotspot.setAttribute('tabindex',-1);
         }
      }

      for (let hideId of ["openManagmentTool","embadedManagment","hybridTool"]) {
         if (document.getElementById(hideId) !== null) {
            document.getElementById(hideId).style.display = 'none';
         }
      }

      window.position = 'reset';
      window.hotspot = '';
      if( !(window.mob || window.isipad)){
         window.scene._nav._navMaxDolly = 27;
      }

      window.document.getElementById("performance").style.display = 'none';
      window.scene.groupApplyState("Heat_Sink_On")
      window.scene.groupApplyState("Top_Door_On");
      window.scene.groupApplyState("Bezel_On");
      window.scene.groupApplyState("Interior_On");
      window.scene.groupApplyState("GP_With_Bezel_On");
      window.scene.groupApplyState("For_Heat_Sink")
      window.scene.groupApplyState("Ref_Plane_With_Bezel_On")
      window.scene.animPlayInTime("Top_Pannel",0.0333333,1);
    
      document.getElementById('intHeader').style.display = 'none';
      document.getElementById('dm-Enclosure').style.display = 'none';
      window.scene.clearRefine();
   }

   const previousAndNextView = (value) => {
      if (!(mob || isipad)) {
         let previous = document.getElementById('previousView');
         if (previous !== null) {
            previous.setAttribute('aria-label',value);
         }
         let next = document.getElementById('nextView');
         if (next !== null) {
            next.setAttribute('aria-label',value);
         }
      }
   }

   /* { Menu Exterior } */
   const onExteriorClick = (isNextPrevious) => {
   //   console.log('onExteriorClick');
      window.selectedButtonG = 'onExteriorClick'
      reverseAll();
      
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Exterior view');

      if (document.getElementById('exteriorViewBtn') !== null) {
         document.getElementById('exteriorViewBtn').classList.add('active');
      }
    
      GotoPosInTimeNamedValue(window.config.front,function () {
         sliderRangeBarUpdate();
         window.scene.groupApplyState("Top_Door_On");
      });

      window.RT_RecordEvent("Exterior","Exterior View",window.config.name);
      window.scene.clearRefine();
   }

   const FrontModeClick = (isNextPrevious) => {

      // console.log('FrontModeClick')
      window.selectedButtonG = 'FrontModeClick'
      reverseAll();
      
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Front view');

      if (document.getElementById('frontBtn') !== null) {
         document.getElementById('frontBtn').classList.add('active');
      }

      window.scene.groupApplyState("Bezel_Off");
      window.scene.groupApplyState("GP_Without_Bezel_On");
      window.scene.groupApplyState("Ref_Plane_Without_Bezel_On")

      GotoPosInTimeNamedValue(window.config.front,function () {
         sliderRangeBarUpdate();
         window.hotspot = 'front';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 3; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 7) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }
      window.RT_RecordEvent("Exterior","Front",window.config.name);
      window.scene.clearRefine();

   }

   const RearModeClick = (isNextPrevious) => {

   //   console.log('RearModeClick')
      window.selectedButtonG = 'RearModeClick'
      reverseAll();
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Rear view');

      if (document.getElementById('rearBtn') !== null) {
         document.getElementById('rearBtn').classList.add('active');
      }
      
      GotoPosInTimeNamedValue(window.config.rear,function () {
         sliderRangeBarUpdate();
         window.hotspot = 'rear';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         for (let i = 8; i <= document.querySelectorAll(".hotspots").length; i++) {
            if (i === 15) break;
            if (window.document.getElementById("hotspot" + i) !== null) {
               window.document.getElementById("hotspot" + i).setAttribute('tabindex',1);
            }
         }
      }

      window.RT_RecordEvent("Exterior","Rear",window.config.name);
      window.scene.clearRefine();
   }

   /* { Menu Interior } */
   const onInterirorClick = (isNextPrevious) => {

   //   console.log('onInterirorClick')
      window.selectedButtonG = 'onInterirorClick'
      reverseAll();
      if( !(window.mob || window.isipad)){
         window.scene._nav._navMaxDolly = 30;
      }
     
      // window.scene._nav.tempfRotMinLimit = 0.001;
      window.scene._nav._panMax  = [22,6];    //[left, bottom];
      window.scene._nav._panMin = [-16, -5];  //[right, top];
      
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Interior view');

      if (document.getElementById('positionBtn') !== null) {
         document.getElementById('positionBtn').classList.add('active');
      }

      
      window.scene.groupApplyState("Interior_On");
      window.scene.groupApplyState("Black_Cover_On");      
      window.scene.groupApplyState("Bezel_Off");
      window.scene.groupApplyState("Ref_Plane_Without_Bezel_On")
      window.scene.groupApplyState("GP_Without_Bezel_On");
         GotoPosInTimeNamedValue(window.config.interior,function () {
            window.hotspot = 'interior';
            document.getElementById('intHeader').style.display = 'none';
            // console.log('anim before')
            window.scene.animPlayInTime("Top_Pannel",0.6660000,animTime,function () {
            window.scene.groupApplyState("Top_Door_Off");
            sliderRangeBarUpdate();
            window.document.getElementById("performance").style.display = 'block';
            window.scene.clearRefine();
         });

      });
      window.scene.clearRefine();
   }

   const onProcessorClick = (isNextPrevious) => {

      // console.log('onProcessorClick')
      window.selectedButtonG = 'onProcessorClick'
      reverseAll();
      clearTimeout(clearSlideSetTimeout.current);
     
      for (let alreadySelected of document.querySelectorAll('.MuiAccordionDetails-root.active,.MuiAccordionDetails-root.select')) {
         if (alreadySelected !== null) {
            alreadySelected.classList.remove('active','select');
         }
      }

      for (let hotspot of document.querySelectorAll(".hotspots")) {
         if (hotspot !== null) {
            hotspot.style.display = 'none';
            hotspot.setAttribute('tabindex',-1);
         }
      }

      for (let hideId of ["openManagmentTool","embadedManagment","hybridTool"]) {
         if (document.getElementById(hideId) !== null) {
            document.getElementById(hideId).style.display = 'none';
         }
      }
      window.position = 'reset';
      window.hotspot = '';
      if( !(window.mob || window.isipad)){
         window.scene._nav._navMaxDolly = 27;
      }
      window.scene._nav._panMax  = [16,6];    //[left, bottom];
      window.scene._nav._panMin = [-25,-10];  //[right, top];
      
      window.scene.animPlayInTime("top",0,1);
      document.getElementById('intHeader').style.display = 'none';
      document.getElementById('dm-Enclosure').style.display = 'none';
      previousAndNextView('Processor');

      if (document.getElementById('processorBtn') !== null) {
         document.getElementById('processorBtn').classList.add('active');
      }
      window.scene.groupApplyState("For_Processor");      
;     window.scene.groupApplyState("Top_Door_Off");
      window.scene.groupApplyState("Bezel_On");
      window.scene.groupApplyState("Interior_On");
      window.scene.groupApplyState("Black_Cover_Off"); 
      window.scene.groupApplyState("Heat_Sink_Off");
      window.scene.groupApplyState("Bezel_Off");
      window.scene.groupApplyState("Ref_Plane_Without_Bezel_On")
      window.scene.groupApplyState("GP_Without_Bezel_On");

      GotoPosInTimeNamedValue(window.config.processor,function () {
         window.hotspot = 'processor';
         sliderRangeBarUpdate();
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot19").setAttribute("tabindex",1);
      }
      window.RT_RecordEvent("Interior","Processor",window.config.name);
      window.scene.clearRefine();
   }

   const onMemoryClick = (isNextPrevious) => {

   //   console.log('onMemoryClick')
      window.selectedButtonG = 'onMemoryClick'
      reverseAll();

      if( !(window.mob || window.isipad)){
         window.scene._nav._navMaxDolly = 27;
      }
      window.scene._nav._panMax  = [22,6];    //[left, bottom];
      window.scene._nav._panMin = [-25,-10];  //[right, top];

      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Memory');

      if (document.getElementById('memoryBtn') !== null) {
         document.getElementById('memoryBtn').classList.add('active');
      }

      window.scene.groupApplyState("Top_Door_Off");
      window.scene.groupApplyState("Interior_On");
      window.scene.groupApplyState("Black_Cover_Off"); 
      window.scene.groupApplyState("Bezel_Off");
      window.scene.groupApplyState("Ref_Plane_Without_Bezel_On")
      window.scene.groupApplyState("GP_Without_Bezel_On");

      GotoPosInTimeNamedValue(window.config.processor,function () {
         sliderRangeBarUpdate();
         window.hotspot = 'memory';
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot20").setAttribute("tabindex",1);
      }
      window.RT_RecordEvent("Interior","Memory",window.config.name);
      window.scene.clearRefine();
   }

   const onFanClick = (isNextPrevious) => {

   //   console.log('onFanClick')
      window.selectedButtonG = 'onFanClick'
      reverseAll();
      if( !(window.mob || window.isipad)){
         window.scene._nav._navMaxDolly = 27;
      }
      window.scene._nav._panMax  = [16,6];    //[left, bottom];
      window.scene._nav._panMin = [-32,-10];  //[right, top];

      /* { Previous and Next setattritube update value here } */
         previousAndNextView('DMEnclosure');

      if (document.getElementById('DMEnclosure') !== null) {
         document.getElementById('DMEnclosure').classList.add('active');
      }
      
      window.scene.groupApplyState("Top_Door_Off");
      window.scene.groupApplyState("Black_Cover_On"); 
      window.scene.groupApplyState("Bezel_Off");
      window.scene.groupApplyState("Ref_Plane_Without_Bezel_On")
      window.scene.groupApplyState("GP_Without_Bezel_On");
      GotoPosInTimeNamedValue(window.config.fans,function () {
         sliderRangeBarUpdate();
         window.hotspot = 'fan';
         document.getElementById('dm-Enclosure').style.display = "none"
         
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo").focus();
         }
      });

      if (!(window.isipad || window.mob)) {
         document.getElementById("hotspot21").setAttribute("tabindex",1);
      }
      window.RT_RecordEvent("Interior","Dynamic Media Enclosure",window.config.name);
      window.scene.clearRefine();
   }

   /* { Menu Software } */

   const onSoftwareClick = (isNextPrevious) => {

   //   console.log('onSoftwareClick')
      window.selectedButtonG = 'onSoftwareClick'
      reverseAll();
      window.dellLogoFix = true;
      
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Software');

      if (document.getElementById('feature') !== null) {
         document.getElementById('feature').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.front,function () {
      sliderRangeBarUpdate();
        window.scene.groupApplyState("Top_Door_On");
         window.hotspot = 'software';
      });
      window.scene.clearRefine();

   }

   const onEmbededClick = (isNextPrevious) => {

      // console.log('onEmbededClick')
      window.selectedButtonG = 'onEmbededClick'
      reverseAll();
      window.scene._nav._panMax  = [20,8];    //[left, bottom];
      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Intelligent Automation');
      window.scene.groupApplyState("Interior_On")

      if (document.getElementById('iAutomation') !== null) {
         document.getElementById('iAutomation').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.insideSoftware,function () {
         sliderRangeBarUpdate();
         window.scene.groupApplyState("Top_Door_On");
         if (window.mob || window.isipad) {
            window.hotspot = 'iAutomation';
         } else {
            document.getElementById("iAutomationTool").style.display = 'block';
         }
         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo2").focus();
         }
   
      });

      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }

      window.RT_RecordEvent("Software","Intelligent Automation",window.config.name);
      window.scene.clearRefine();

   }

   const onOpenManageClick = (isNextPrevious) => {

      // console.log('onOpenManageClick')
      window.selectedButtonG = "onOpenManageClick"
      reverseAll();

      /* { Previous and Next setattritube update value here } */
      previousAndNextView('Cyber Resiliency');
      window.scene.groupApplyState("Interior_On");
      window.scene.groupApplyState("Top_Door_On");

      if (document.getElementById('cResiliency') !== null) {
         document.getElementById('cResiliency').classList.add('active');
      }

      GotoPosInTimeNamedValue(window.config.insideSoftware,function () {
         sliderRangeBarUpdate();
         (window.mob || window.isipad) && (window.hotspot = 'cResiliency');
         !(window.mob || window.isipad) && (document.getElementById("cResiliencyTool").style.display = 'block')

         if (isNextPrevious != true) {
            window.document.getElementById("hotspot1demo2").focus();
         }
      });

      if (!(window.isipad || window.mob)) {

         document.getElementById("hotspot1").setAttribute("tabindex","-1");
         document.getElementById("hotspot2").setAttribute("tabindex","-1");
         document.getElementById("hotspot3").setAttribute("tabindex","-1");
         document.getElementById("hotspot4").setAttribute("tabindex","-1");
         document.getElementById("hotspot5").setAttribute("tabindex","-1");
         document.getElementById("hotspot6").setAttribute("tabindex","-1");
         document.getElementById("hotspot7").setAttribute("tabindex","-1");
         document.getElementById("hotspot8").setAttribute("tabindex","-1");
         document.getElementById("hotspot9").setAttribute("tabindex","-1");
         document.getElementById("hotspot10").setAttribute("tabindex","-1");
         document.getElementById("hotspot11").setAttribute("tabindex","-1");
         document.getElementById("hotspot12").setAttribute("tabindex","-1");
         document.getElementById("hotspot13").setAttribute("tabindex","-1");
         document.getElementById("hotspot14").setAttribute("tabindex","-1");
         document.getElementById("hotspot15").setAttribute("tabindex","-1");
         document.getElementById("hotspot16").setAttribute("tabindex","-1");
         document.getElementById("hotspot17").setAttribute("tabindex","-1");
         document.getElementById("hotspot18").setAttribute("tabindex","-1");
         document.getElementById("rLeft").setAttribute("tabindex","0");
         document.getElementById("rRight").setAttribute("tabindex","0");
         document.getElementById("zoomOut").setAttribute("tabindex","0");
         document.getElementById("sliderRange").setAttribute("tabindex","0");
         document.getElementById("zoomIn").setAttribute("tabindex","0");
         document.getElementById("previousView").setAttribute("tabindex","0");
         document.getElementById("resetView").setAttribute("tabindex","0");
         document.getElementById("nextView").setAttribute("tabindex","0");

      }
      window.RT_RecordEvent("Software","Cyber Resiliency",window.config.name);
      window.scene.clearRefine();

   }

   /* { Reset } */
   const resetMode = () => {
      window.selectedButtonG = "onResetMode"
      window.hotspot = '';
      GotoPosInTimeNamedValue(window.config.reset);
   }

   const menuSelectedButton = (menuSelectItem,expandedPanel = false) => {

      if (menuSelectItem === 'onExteriorClick') {
         expandedPanel && setExpandedPanel("panel2");
         onExteriorClick(true);
      }
      else if (menuSelectItem === 'FrontModeClick') {
         expandedPanel && setExpandedPanel("panel2");
         FrontModeClick(true);
      }
      else if (menuSelectItem === 'RearModeClick') {
         expandedPanel && setExpandedPanel("panel2");
         RearModeClick(true);
      }
      else if (menuSelectItem === 'onInterirorClick') {
         expandedPanel && setExpandedPanel("panel5");
         onInterirorClick(true);
      }
      else if (menuSelectItem === 'onProcessorClick') {
         expandedPanel && setExpandedPanel("panel5");
         onProcessorClick(true);
      }
      else if (menuSelectItem === 'onMemoryClick') {
         expandedPanel && setExpandedPanel("panel5");
         onMemoryClick(true);
      }
      else if (menuSelectItem === 'onFanClick') {
         expandedPanel && setExpandedPanel("panel5");
         onFanClick(true);
      }
      else if (menuSelectItem === 'onSoftwareClick') {
         expandedPanel && setExpandedPanel("panel3");
         onSoftwareClick(true);
      }
      else if (menuSelectItem === 'onEmbededClick') {
         expandedPanel && setExpandedPanel("panel3");
         onEmbededClick(true);
      }
      else if (menuSelectItem === 'onOpenManageClick') {
         expandedPanel && setExpandedPanel("panel3");
         onOpenManageClick();
      }
      else if (menuSelectItem === 'onResetMode') {
         resetMode();
      }
   }

   const onResetMode = () => {
      sliderRangeBarUpdate();
      menuSelectedButton(window.selectedButtonG,false);
      window.scene.clearRefine();
   }

   const onPreviousMode = () => {
      sliderRangeBarUpdate();
      if (document.getElementById("bEfficiencyTool") !== null) {
         document.getElementById("bEfficiencyTool").style.display = 'none';
      }
      if (document.getElementById("iAutomationTool") !== null) {
         document.getElementById("iAutomationTool").style.display = 'none';
      }
      if (document.getElementById("cResiliencyTool") !== null) {
         document.getElementById("cResiliencyTool").style.display = 'none';
      }
      var prevButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === window.selectedButtonG)
      if (window.selectedButtonG === 'onExteriorClick' || window.selectedButtonG === 'onResetMode') {
         prevButton = 'onOpenManageClick';
      } else {
         prevButton = buttonSeq[selectedButtonIndex - 1];
      }

      menuSelectedButton(prevButton,true);
      return false;
   }

   const onNextMode = () => {
      // console.log('on next mode ')
      sliderRangeBarUpdate();
      if (document.getElementById("bEfficiencyTool") !== null) {
         document.getElementById("bEfficiencyTool").style.display = 'none';
      }
      if (document.getElementById("iAutomationTool") !== null) {
         document.getElementById("iAutomationTool").style.display = 'none';
      }
      if (document.getElementById("cResiliencyTool") !== null) {
         document.getElementById("cResiliencyTool").style.display = 'none';
      }

      var nextButton;
      var selectedButtonIndex = buttonSeq.findIndex(element => element === window.selectedButtonG)
      if (window.selectedButtonG === 'onOpenManageClick') {
         nextButton = 'onExteriorClick';
      }
      else {
         nextButton = buttonSeq[selectedButtonIndex + 1];
      }
      // console.log('nextButton',nextButton)
      menuSelectedButton(nextButton,true);
      return false;
   }

   useEffect(() => {
      window.Animation = 'on';
      setAnimValue("on");
      document.getElementsByClassName('onOff')[0].style.left = "-17px";
      document.getElementById("animSwitchValue").checked = true;
      document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked on');

      if (!(window.mob && window.innerWidth < window.innerHeight)) {
         document.getElementById("animSwitchValue1").setAttribute('aria-label','Animation on');
         setAnimValue1("on");
         document.getElementById("animSwitchValue1").checked = true;
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }

      return () => {
         return false
      }
   },[]);

   const setAnimationSwitch = (e) => {

      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';

      } else {
         document.getElementById("animSwitchValue").checked = true;
         setAnimValue("on");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

      }
   }

   const displayName = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;
      if (isChecked == true) {
         setAnimValue("on");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked on');

      } else {
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         document.getElementById('animSwitchValue').setAttribute('aria-label','clickable checkbox checked Off');

      }

   }

   const setAnimationSwitch1 = (e) => {

      const isChecked = document.getElementById("animSwitchValue1").checked;
      if (isChecked == true) {
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';
      }
      else {
         document.getElementById("animSwitchValue1").checked = true;
         setAnimValue1("on");
         window.animationSwitchVal = 'on';
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
      }
   }

   var animStopped = true;
   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }

      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (window.isipad) {
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";
            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
         }

      } else {
         setAnimValue1("Off");
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animation1SwitchGlobal = 'off';
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked Off');

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (window.isipad) {
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "-118px";
            setTimeout(function () {
               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";
               animStopped = true;
            },200);
         }
      }
   }

   return (
      <>
         {!mob && <HowToUse />}
         <Hidden only={['sm','md','lg','xl']}>
            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }} variant="outlined" color="primary" classes={{ endIcon: 'menuEndIcon' }} endIcon={<img src="./img/cross.svg" alt="cross" style={{height: '23px' }} />}onClick={props.toggleDrawerAction}>
               {window.finalLangues?.mainmenu}
            </Button>
            <Howtousenew />

         </Hidden>
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" 
               onReset={onResetMode} onPrevious={onPreviousMode} 
               onNext={onNextMode} 
            />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} 
              onPreviousMob={onPreviousMode} onNextMob={onNextMode} 
              onResetIpad={onResetMode} onNextIpad={onNextMode} 
              onPreviousIpad={onPreviousMode} 
            />
         </Hidden>
         <MenuExteriorView 
            name={window.finalLangues.port2} 
            tabIndex="1" onExterior={onExteriorClick} 
            onFrontMode={FrontModeClick} onRearMode={RearModeClick} 
            expanded={expandedPanel === 'panel2'} 
            onChanged={handleAccordionChange('panel2')} 
         />

         <MenuInterierView 
          name={window.finalLangues.port3} tabIndex="1" 
          onProcessorBtnClick={onProcessorClick} onMemoryBtnClick={onMemoryClick} 
          onDMEnclosureClick={onFanClick} 
          onInterirorBtnClick={onInterirorClick} expanded={expandedPanel === 'panel5'} 
          onChanged={handleAccordionChange('panel5')} 
         />

         <MenuSoftware name={window.finalLangues.port4} 
            tabIndex="1" onIAutomationClicked={onEmbededClick}  
            onCResiliencyClicked={onOpenManageClick} 
            onSoftware={onSoftwareClick} 
            expanded={expandedPanel === 'panel3'} 
            onChanged={handleAccordionChange('panel3')} 
         />

         <AnimationBtn 
          onchange={displayName} 
          forKeypress={setAnimationSwitch} 
          value={animValue} onchange1={displayName1} 
          forKeypress1={setAnimationSwitch1} value1={animValue1} 
         />

      </>
   );
}

export default MainMenu;